/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsPresentationOptions } from './FxIdDomainSettingsPresentationOptions';
import {
    instanceOfFxIdDomainSettingsPresentationOptions,
    FxIdDomainSettingsPresentationOptionsFromJSON,
    FxIdDomainSettingsPresentationOptionsFromJSONTyped,
    FxIdDomainSettingsPresentationOptionsToJSON,
} from './FxIdDomainSettingsPresentationOptions';

/**
 * @type FxIdWebFeaturesPlayGameResponsePresentation
 * 
 * @export
 */
export type FxIdWebFeaturesPlayGameResponsePresentation = FxIdDomainSettingsPresentationOptions;

export function FxIdWebFeaturesPlayGameResponsePresentationFromJSON(json: any): FxIdWebFeaturesPlayGameResponsePresentation {
    return FxIdWebFeaturesPlayGameResponsePresentationFromJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponsePresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesPlayGameResponsePresentation {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPresentationOptions(json)) {
        return FxIdDomainSettingsPresentationOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesPlayGameResponsePresentationToJSON(json: any): any {
    return FxIdWebFeaturesPlayGameResponsePresentationToJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponsePresentationToJSONTyped(value?: FxIdWebFeaturesPlayGameResponsePresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsPresentationOptions(value)) {
        return FxIdDomainSettingsPresentationOptionsToJSON(value as FxIdDomainSettingsPresentationOptions);
    }

    return {};
}

